import axios from 'axios'
import React, { useState } from 'react'
import { ExchangeRatesView } from './ExchangeRatesView'

export const ExchangeRates = () => {
    const [currencyPair, setCurrencyPair] = useState('GBP-EU')
    const [currencyValue, setCurrencyValue] = useState(0)

    const onSelectCurrencyPair = (e) => {
        setCurrencyPair(e.target.value)
        console.log(e.target.value)
    }

    const onChangeCurrencyValue = (e) => {
        setCurrencyValue(e.target.value)
        console.log(currencyValue)
    }

    const onSubmit = () => {
        axios.post(process.env.REACT_APP_HOST + 'api/exchangeRates/add', {
            params: {
                currencyPair: currencyPair,
                currencyValue: currencyValue
            }
        }).then((res) => {
            console.log(res.data)
        }).catch((err) => {
            console.log(err)
        })
    }

    

    return <ExchangeRatesView
        currency={currencyPair}
        onSelectCurrencyPair={onSelectCurrencyPair}
        onChangeCurrencyValue={onChangeCurrencyValue}
        onSubmit={onSubmit}
    />
}